import { Box, TextField } from "@radix-ui/themes";
import { Control, Controller, FieldErrors, FieldValues, Path } from "react-hook-form";
import {
  ComposedName,
  FieldShell,
  fieldAria,
  fieldIds,
  resolveFieldError,
} from "../FieldShell";

interface TextFieldProps<T extends FieldValues> {
  name: Path<T>; // Agora restrito apenas a chaves de `T`
  label: string;
  control: Control<T>;
  errors: FieldErrors<T>;
  style?: any;
  fieldProps?: any;
  composedName?: ComposedName;
  required?: boolean;
  hint?: string;
}

const TextFieldComponent = <T extends FieldValues>({
  name,
  label,
  control,
  errors,
  style,
  fieldProps,
  composedName,
  required,
  hint,
}: TextFieldProps<T>) => {
  const error = resolveFieldError(errors, name, composedName);
  const { fieldId } = fieldIds(name);

  return (
    <Box {...style}>
      <FieldShell name={name} label={label} required={required} error={error} hint={hint}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <TextField.Root
              size="2"
              id={fieldId}
              color={error ? "red" : undefined}
              {...fieldAria(name, error, hint)}
              {...field}
              {...fieldProps}
              value={field.value ?? ""}
            />
          )}
        />
      </FieldShell>
    </Box>
  );
};

export default TextFieldComponent;
